module.exports = __webpack_public_path__ + "static/media/grid_img6.8d8f8b83.webp";